export default __webpack_public_path__ + "static/media/icon_customer_ob.0155d4cd.svg";